import { ApolloLink } from '@apollo/client';

let visitorIdValue = '';

export const setVisitorId = (visitorId: string) => {
  visitorIdValue = visitorId;
};

export const visitorIdLink = new ApolloLink((operation, forward) => {
  operation.setContext(({ headers = {} }) => ({
    headers: {
      ...headers,
      'x-visitor-id': visitorIdValue,
    },
  }));

  return forward(operation);
});
